import { Controller } from '@hotwired/stimulus';

/**
 * 組合員情報の編集画面を開いた時点の内容を表すトークンを、画面内のフォームに hidden で足すStimulusコントローラ（要件4-2）
 * 既存のフォームに手を入れずに、保存時に「どの時点の画面から送ったか」をサーバーへ伝えるために使う。
 * トークンが届かない保存はサーバー側で拒否するため、JavaScript が動かなくても上書きは起きない。
 * @extends Controller
 */
export default class extends Controller {
  static values = { token: String };

  connect() {
    document.querySelectorAll('main form').forEach((form) => {
      if (this.element.contains(form) || form.querySelector('input[name="member_info_token"]')) return;

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'member_info_token';
      input.value = this.tokenValue;
      form.appendChild(input);
    });
  }
}
